var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3a13 13 0 1 0 0 26 13 13 0 0 0 0-26Zm10.95 12h-4.97a18.65 18.65 0 0 0-3.14-9.63A11.02 11.02 0 0 1 26.95 15ZM16 26.99A16.03 16.03 0 0 1 12.03 17h7.94A16.04 16.04 0 0 1 16 26.99ZM12.03 15A16 16 0 0 1 16 5.01 16.03 16.03 0 0 1 19.97 15h-7.94Zm1.13-9.63A18.65 18.65 0 0 0 10.04 15H5.04a11.03 11.03 0 0 1 8.11-9.63ZM5.05 17h4.98a18.65 18.65 0 0 0 3.13 9.63A11.03 11.03 0 0 1 5.05 17Zm13.79 9.63A18.67 18.67 0 0 0 21.98 17h4.97a11.03 11.03 0 0 1-8.11 9.63Z"}));
}

Globe.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Globe;

Globe.default = Globe;
